namespace GeniuzPOS.Administration {
    export class PsPosFuncColumns {
        static columnsKey = 'Administration.PsPosFunc';
    }
}
